// extracted by mini-css-extract-plugin
export var cardIcon = "_5i-4";
export var checkboxCard = "_5i-0";
export var checkboxCardSelected = "_5i-3";
export var disabled = "_5i-1";
export var outerBorder = "_5i-2";
export var spacerMedium = "_5i-7";
export var spacerSmall = "_5i-6";
export var spacerXsmall = "_5i-5";